<template>
  <q-page class="flex-center">
    <div class="q-pa-md">
      <q-table
        title="Doadores"
        :data="donators"
        :columns="columns"
        row-key="id"
        :visible-columns="visibleColumns"
        :loading="isLoading"
        :pagination.sync="pagination"
        @request="onRequest"
      >
        <template v-slot:top="props">
          <div class="row col-12 q-col-gutter-xs">
            <div class="col-12 text-center text-h3">Doadores</div>
          </div>

          <div class="row col-12">

            <div class="col-5 ">
              <q-input outlined style="border: 1px solid white;" dense input-class="inputSearch" debounce="300"
                    @input="mudaInput" v-model="filter"
                    placeholder="Buscar">
              </q-input>
            </div>

            <div class="col-5">
             <select class='form-control' v-model="statusFilter" @change="mudaInput">
              <option value=''>  </option>
              <option value='1'> Ativo </option>
              <option value='4'> Atraso 1 </option>
              <option value='2'> Atraso 2 </option>
              <option value='9'> Inativo </option>
             </select>
            </div>

            <!--
            <div class="col-5 ">
              <q-select
                v-model="visibleColumns"
                multiple
                dense
                options-dense
                emit-value

                label="Colunas visíveis"
                :options="columns"
                option-value="name"
                outlined
                style="min-width: 150px; border: 1px solid white;"
              />
            </div>
            -->


            <div class="col-1 text-center">
              <q-btn color="bg-purple-10" outline icon="add" @click="$router.push({name:'donator.new'})"></q-btn>
            </div>
            <div class="col-1  text-center">
              <q-btn color="bg-purple-10" class="block" outline icon="cloud_download" type="a" target="_blank"
                     :href="linkExcel"></q-btn>
            </div>
          </div>
        </template>

        <template v-slot:body-cell-options="value">
          <q-td>
            <q-btn round color="primary" @click="mudaComboOption(value)" icon="visibility"/>
          </q-td>

          <q-td>
            <q-btn round color="primary" @click="editDonator(value)" icon="edit"/>
          </q-td>

          <q-td>
            <q-btn round color="primary" @click="editPassword(value)" icon="lock"/>
          </q-td>
        </template>


      </q-table>
    </div>

    <q-dialog v-model="alert">
      <q-card style="width: 80vw; max-width: 80vw;">
        <q-card-section>

          <div class="row">
          <!--
            <div class="col-11">
              <div class="text-h6">Dados de {{donator_name}}</div>
            </div>
            -->
            <!--
            <div class="col-1">
              <q-btn color="primary" icon="create"
                     @click="$router.push({name:'donator.edit',params: {id: donator_id}})"></q-btn>
            </div>-->
            <!--
            <div class="col-1">
              <q-btn color="primary" icon="headset_mic"
                     @click="$router.push({name:'atendimento',params: {id: donator_id}})"></q-btn>
            </div>
            -->
          </div>
        </q-card-section>

        <list-donations v-if="this.modalState === 'listDonations'"
          :admin="true"
          @listReceipts="setModalState"
          @valueForm="setModalState"
          :alert="alert"
          :donator_id="donator_id"
          :donator_name="donator_name"
          @loading="loadingChange"
        />

        <list-receipts  v-if="this.modalState === 'listReceipts'"
          :admin="true"
          :donationId="donationId"
          @listDonations="setModalState"
        />

        <value-form  v-if="this.modalState === 'valueForm'"
          :admin="true"
          :editing="true"
          :donationId="donationId"
          @listDonations="setModalState"
        />

        <personal-data-form  v-if="this.modalState === 'PersonalDataForm'"
          :admin="true"
          :editing="true"
          :donator="findCurrentDonator()"
          @listDonations="setModalState"
        />

        <change-password-form  v-if="this.modalState === 'ChangePasswordForm'"
          :donator="findCurrentDonator()"
        />

        <!--
        <q-card-actions align="right" class="bg-white text-primary">
          <q-btn flat color="primary" label="Fechar" @click="alert = false"/>
        </q-card-actions>
         -->
        <q-inner-loading :showing="loadingDonations">
          <q-spinner-dots size="50px" color="primary"/>
        </q-inner-loading>

        <br>
        <br>

      </q-card>
    </q-dialog>

  </q-page>
</template>

<script>
// import { DONATORSSTRING2 } from '../graphql/graphql';
import { DateTime } from 'luxon';
import { getDonators } from './microfrontend/apiClient';
import { setupAxios } from './microfrontend/setupAxios';
// import Donations from './Donations';
import ListDonations from './microfrontend/DonationsManager/ListDonations/index';
import ListReceipts from './microfrontend/DonationsManager/ListReceipts';
import ValueForm from './microfrontend/doe-agora/ValueForm/ValueForm';
import PersonalDataForm from './microfrontend/doe-agora/PersonalDataForm/PersonalDataForm';
import ChangePasswordForm from './ChangePasswordForm';

export default {
  name: 'Doadores',
  components: { ListDonations, ListReceipts, ValueForm, PersonalDataForm, ChangePasswordForm },
  data () {
    return {
      modalState: '',
      donators: [],
      donationId: undefined,
      isLoading: false,
      filter: '',
      statusFilter: '',
      visibleColumns: [
        'id',
        'full_name',
        'document',
        'email'
      ],
      donatorsByString2: {
        data: [],
        paginatorInfo: {
          total: 0
        }
      },
      donatorsByString: {
        data: [],
        paginatorInfo: {
          total: 0
        }
      },
      statusDoador: [],
      statusDoadorOptions: [
        { id: 1, name: 'Ativo' },
        { id: 4, name: 'Atraso 1' },
        { id: 2, name: 'Atraso 2' },
        { id: 9, name: 'Inativo' },
        // { id: 13, name: 'Cancelado' },
        // { id: 12, name: 'Prospect' }
      ],
      options: [],
      optionOptions: [
        { id: 1, name: 'Ativo' },
        { id: 4, name: 'Atraso 1' }
      ],
      formaPagamento: [],
      formaPagamentoOptions: [
        { id: 1, name: 'Boleto' },
        { id: 9, name: 'Cartão de crédito' },
        { id: 11, name: 'Débito automático' },
        { id: 12, name: 'PayPal' },
        { id: 13, name: 'Transferência Identificada' },
        { id: 14, name: 'Transferência sem relacionamento' },
        { id: 15, name: 'Pólen' },
        { id: 16, name: 'Presente solidário' }
      ],
      formaEnvio: [],
      formaEnvioOptions: [
        { id: 1, name: 'Correio' },
        { id: 2, name: 'E-mail' }
      ],
      tipoDoador: [],
      tipoDoadorOptions: [
        { id: 1, name: 'Regular' },
        { id: 2, name: 'Único' },
        { id: 3, name: 'Ocasional' }
      ],
      loading: true,
      columns: [
        {
          name: 'id',

          label: 'ID do doador',
          align: 'left',
          field: 'id',
          required: true

        }, {
          name: 'full_name',
          label: 'Nome do doador',
          align: 'left',
          field: 'full_name',
          required: true

        }, {
          name: 'document',

          label: 'Documento do doador',
          align: 'left',
          field: 'document',
          format: val => {
            if (val) {
              let v = val
              v = v.replace(/\D/g, '')

              if (v.length < 14) { // CPF
                // Coloca um ponto entre o terceiro e o quarto dígitos
                v = v.replace(/(\d{3})(\d)/, '$1.$2')

                // Coloca um ponto entre o terceiro e o quarto dígitos
                // de novo (para o segundo bloco de números)
                v = v.replace(/(\d{3})(\d)/, '$1.$2')

                // Coloca um hífen entre o terceiro e o quarto dígitos
                v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
              } else { // CNPJ
                // Coloca ponto entre o segundo e o terceiro dígitos
                /*  v = v.replace(/^(\d{2})(\d)/, '$1.$2')

                // Coloca ponto entre o quinto e o sexto dígitos
                v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')

                // Coloca uma barra entre o oitavo e o nono dígitos
                v = v.replace(/\.(\d{3})(\d)/, '.$1/$2')

                // Coloca um hífen depois do bloco de quatro dígitos
                v = v.replace(/(\d{4})(\d)/, '$1-$2') */
                v = v.replace(/\D/g, '') // Remove tudo o que não é dígito
                v = v.replace(/^(\d{2})(\d)/, '$1.$2') // Coloca ponto entre o segundo e o terceiro dígitos
                v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3') // Coloca ponto entre o quinto e o sexto dígitos
                v = v.replace(/\.(\d{3})(\d)/, '.$1/$2') // Coloca uma barra entre o oitavo e o nono dígitos
                v = v.replace(/(\d{4})(\d)/, '$1-$2')
              }

              return v
            }
          }

        }, {
          name: 'email',

          label: 'Email do doador',
          align: 'left',
          field: 'email'

        }, {
          name: 'street',

          label: 'Logradouro',
          align: 'left',
          field: 'street'

        }, {
          name: 'number',

          label: 'Número',
          align: 'left',
          field: 'number'

        }, {
          name: 'complement',

          label: 'Complemento',
          align: 'left',
          field: 'complement'

        }, {
          name: 'neighborhood',

          label: 'Bairro',
          align: 'left',
          field: 'neighborhood'

        }, {
          name: 'city',

          label: 'Cidade',
          align: 'left',
          field: 'city'

        }, {
          name: 'state',

          label: 'Estado',
          align: 'left',
          field: 'state'

        }, {
          name: 'zipcode',

          label: 'CEP',
          align: 'left',
          field: 'zipcode'

        }, {
          name: 'tel_res',

          label: 'Telefone residencial',
          align: 'left',
          field: 'tel_res'

        }, {
          name: 'tel_cel',

          label: 'Celular',
          align: 'left',
          field: 'tel_cel'

        }, {
          name: 'tel_com',

          label: 'Telefone comercial',
          align: 'left',
          field: 'tel_com'
        }, {
          name: 'birthday',

          label: 'Data de nascimento',
          align: 'left',
          field: 'birthday',

          format: val => {
            if (val) return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString();
          }

        }, {
          name: 'created_at',

          label: 'Data de cadastro',
          align: 'left',
          field: 'created_at',

          format: val => {
            if (val) return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString(DateTime.DATETIME_SHORT);
          }
        }, {
          name: 'updated_at',

          label: 'Última alteração',
          align: 'left',
          field: 'updated_at',

          format: val => {
            if (val) return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString(DateTime.DATETIME_SHORT);
          }
        }, {
          name: 'sex',

          label: 'Sexo',
          align: 'left',
          field: 'sex',

          format: val => {
            if (val === 1 || val === 'M') {
              return 'Masculino';
            }
            if (val === 2 || val === 'F') {
              return 'Feminino';
            }
          }
        }, {
          name: 'donator_status',

          label: 'Status do doador',
          align: 'left',
          field: 'donator_status',
          format: val => { if (val) return val.name }

        },
        {
          name: 'options',
          label: 'Doações',
          align: 'left',
          field: 'options',
          required: true
        },
        {
          name: 'editar',
          label: 'Editar',
          align: 'left',
          field: 'edit',
          required: true
        },
        {
          name: 'senha',
          label: 'Senha',
          align: 'left',
          field: 'edit',
          required: true
        }
      ],
      pagination: {
        sortBy: 'name',
        descending: false,
        page: 1,
        rowsPerPage: 50,
        rowsNumber: 50
      },
      alert: false,
      loadingDonations: false,
      donator_name: '',
      donator_id: ''
    };
  },
  computed: {
    linkExcel () {
      const host = process.env.VUE_APP_HOST.replace('graphql', 'excel');
      const token = localStorage.getItem('token');
      const variavbles = [];
      if (this.statusDoador.length > 0) {
        variavbles.push('donator_status_id=' + encodeURIComponent(this.statusDoador));
      }
      if (this.formaPagamento.length > 0) {
        variavbles.push('payment_form_id=' + encodeURIComponent(this.formaPagamento));
      }
      if (this.formaEnvio.length > 0) {
        variavbles.push('shipping_method_id=' + encodeURIComponent(this.formaEnvio));
      }
      if (this.tipoDoador.length > 0) {
        variavbles.push('donator_type_id=' + encodeURIComponent(this.tipoDoador));
      }
      let query = variavbles.join('&');
      return `${host}?${query}&token=${token}`;
    }
  },
  methods: {
    loadingChange () {
      this.loadingDonations = false;
    },
    mudaComboOption (data) {
      this.alert = true;
      this.donator_id = data.row.id;
      this.donator_name = data.row.full_name;
      this.modalState = 'listDonations';
    },
    editDonator (data) {
      this.alert = true;
      this.donator_id = data.row.id;
      this.donator_name = data.row.full_name;
      this.modalState = 'PersonalDataForm';
    },
    editPassword (data) {
      this.alert = true;
      this.donator_id = data.row.id;
      this.modalState = 'ChangePasswordForm';
    },
    findCurrentDonator () {
      return this.donators.find(d => d.id === this.donator_id);
    },
    mudaCombo () {
      console.log('mudaCombo');
      this.$apollo.queries.donatorsByString2.setVariables({
        'page': this.pagination.page || 1,
        'count': this.pagination.rowsPerPage || 50,
        'payment_form_id': this.formaPagamento,
        'donator_status_id': this.statusDoador,
        'donator_type_id': this.tipoDoador,
        'shipping_method_id': this.formaEnvio,
        orderBy: [{ field: 'full_name', order: 'ASC' }]
      });
      this.$apollo.queries.donatorsByString2.refetch().then(result => {
        this.pagination.rowsNumber = result.data.donatorsByString2.paginatorInfo.total;
      });
    },

    async mudaInput () {
      await this.getDonators();
    },
    async onRequest (props) {
      console.log('onRequest', props);
      this.pagination = { ...props.pagination };
      // @todo: nem sempre precisa buscar dnv
      await this.getDonators();
    },
    async getDonators () {
      console.log('pagination', this.pagination);
      this.isLoading = true;
      const res = await getDonators(this.axios, { ...this.pagination, filter: this.filter, statusFilter: this.statusFilter });
      this.isLoading = false;
      console.log('res', res);
      if (res) {
        const { donators, total } = res.data;
        this.donators = donators;
        this.pagination = { ...this.pagination, rowsNumber: total };
      }
      console.log('res', res);
    },
    setModalState (data) {
      console.log('setModalState', data);
      this.modalState = data.event;
      this.donationId = data.donationId;
    }
  },
  async mounted () {
    this.axios = setupAxios();
    await this.getDonators();
  }
};
</script>
<style>
  .q-table__top,
  .q-table__bottom,
  .q-icon,
  thead tr:first-child th {

    background-color: #590a7f;
    color: #ffffff !important;
  }

  .q-table__middle {
    max-height: 600px;
  }

  thead tr:first-child th {
    position: sticky;
    top: 0;
    opacity: 1;
    z-index: 1;
  }

  .row {
    margin: 0;
  }

  input[type='text'].inputSearch {
    color: white !important;
  }

  .q-table__top {
    border-bottom: 3px solid white;
  }
</style>
